module.exports = "<app-main-layout>\n  <router-outlet></router-outlet>\n</app-main-layout>\n"